// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconFolderBottom = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '40',
      height: '28',
      viewBox: '0 0 40 28',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M37.65 5.70909C37.0294 5.34741 36.3239 5.15712 35.6056 5.15758H16.7444C15.6961 5.15468 14.7648 4.48799 14.4243 3.49665L14.2856 3.04962C13.7242 1.38791 12.1678 0.267621 10.4138 0.262879H4.60533C3.90438 0.256073 3.2146 0.438097 2.60826 0.78991C1.32238 1.50952 0.525985 2.8682 0.526367 4.34184V23.921C0.526367 26.1737 2.35258 27.9999 4.60533 27.9999H35.6056C37.8583 27.9999 39.6845 26.1737 39.6845 23.921V9.23662C39.6896 7.78057 38.9128 6.4339 37.65 5.70909Z',
      fill: 'current'
    })
  );

export { IconFolderBottom };
